export default "__VITE_ASSET__CVQkCU4F__"